package devxertech.com

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import devxertech.com.component.CustomStyles
import org.jetbrains.compose.web.css.vh


@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    SilkApp {
        CustomStyles()
        Surface(SmoothColorStyle.toModifier().minHeight(100.vh)) {
            content(

            )
        }
    }
}
